import { Field, Formik, useFormikContext } from 'formik';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import services from '../../services';
import { setUserIP, selectUserIP } from '../../store/user';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { isValidPhoneNumber, AsYouType } from 'libphonenumber-js';
import { BASKET_CACHE_KEY, HandleLocalStorage } from '../../utils/handleLocalStorage';
import { toast } from 'react-toastify';
// import { Base64 } from 'js-base64';
import HandleShowRecurring from '../../utils/showRecurringOnDataLayer';
import { sha256 } from 'js-sha256';
import ShowCurrencies from '../../utils/showCurrencies';
import CheckBox from '../general/checkbox';
import Select from 'react-select';
// import HandleShowAdminCost from '../../utils/handleAdminCost';
import { useLocation, useNavigate } from 'react-router-dom';
import AddressField from './components/addressField';
import IsGTMScriptLoaded from '../../utils/isGTMScriptLoaded';
import { generateLinkWithLang } from '../../utils/linkGenerator';
import { useTranslation } from 'react-i18next';
import { getUTMData } from '../../utils/utmUtils';
import { generateFingerprint } from '../../utils/fingerprintUtils';
import useDomainRegion from '../../hooks/useDomainRegion';
import { getDomainRegion } from '../../hooks/useDomainRegion';
const styles = {
  menuList: base => ({
    ...base,
    '::-webkit-scrollbar': {
      width: '6px',
      height: '0px',
    },
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#888',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
    '& *': {
      cursor: 'pointer',
    },
  }),
};

const getCookie = name => {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find(row => row.startsWith(`${name}=`));
  return cookie ? JSON.parse(decodeURIComponent(cookie.split('=')[1])) : null;
};

const StepTwoWithLocalStorage = props => {
  const { isLaylatulQadr, setStripeCustomerId, setPaymentFlow } = props;
  const userData = getCookie('user_data');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userIP = useSelector(selectUserIP);
  const [isLoading, setIsLoading] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [pastedValue, setPastedValue] = useState('');
  const [basketStates, setBasketStates] = useState({});
  const [phoneCountryName, setPhoneCountryName] = useState('');
  const [countryCode, setCountryCode] = useState('AU');
  const [countryName, setCountryName] = useState('Australia');
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const [isUkTaxPayer, setIsUkTaxPayer] = useState(basketStates.currency === 'GBP' ? true : false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [fingerprint, setFingerprint] = useState(null);
  const adobeBeginCheckoutFired = useRef(false); // prevent duplicate begin_checkout
  const [userInfo, setUserInfo] = useState({
    name: basketStates.donor && basketStates.donor.name ? basketStates.donor.name : userData && userData.name ? userData.name : '',
    email: basketStates.donor && basketStates.donor.email ? basketStates.donor.email : userData && userData.email ? userData.email : '',
    phone: basketStates.donor && basketStates.donor.phone ? basketStates.donor.phone : userData && userData.phone ? userData.phone : '',
    phone_country_code: basketStates.donor ? basketStates.donor.phone_country_code : '',
    phone_country_name: basketStates.donor ? basketStates.donor.phone_country_name : '',
    currency: basketStates.currency ? basketStates.currency : 'AUD',
    referal: document.referrer,
    address: basketStates.donor ? basketStates.donor.address : '',
    city: basketStates.donor ? basketStates.donor.city : '',
    postal_code: basketStates.donor ? basketStates.donor.postal_code : '',
    isUkTaxPayer: basketStates.donor ? basketStates.donor.isUkTaxPayer : false,
    isRemember: basketStates.donor?.isRemember ?? true,
  });
  const [ciDialCode, setCiDialCode] = useState(false);
  const location = useLocation();
  // Use the domain region hook with full location to respond to both domain and SPA route changes
  const domainRegion = useDomainRegion(window.location.origin + location.pathname);
  

  /* ---------------------------------------------------------------------- */
  /* ------------------------ Adobe Analytics helpers --------------------- */
  /* ---------------------------------------------------------------------- */

  // Build and push the "begin_checkout" event (fires once on page load)
  const pushBeginCheckoutAdobe = () => {
    const tempItems =
      basketStates.products && basketStates.products[0] && basketStates.products[0].product
        ? basketStates.products.map(item => ({
            item_id: item.product.creator,
            item_name: item.product.name,
            item_brand: item.product.category || '',
            item_description: item.product.description || '',
            item_category: item.product.category || '',
            price: item.amount,
            quantity: item.quantity,
            currency: basketStates.currency ? basketStates.currency.toUpperCase() : '',
          }))
        : [];

    const adobeData = {
      event: 'begin_checkout',
      page_info: {
        page_url: window.location.href,
        page_title: document.title,
        page_type: 'Checkout',
        language: i18n.language,
      },
      items: tempItems,
      order_summary: {
        admin_contribution: basketStates.adminCost || 0,
        donation_contribution:
          basketStates.grandTotal && basketStates.adminCost !== undefined ? basketStates.grandTotal - basketStates.adminCost : '',
        total_value: basketStates.grandTotal || '',
        donation_frequency: HandleShowRecurring(basketStates.recurring),
        currency: basketStates.currency ? basketStates.currency.toUpperCase() : '',
      },
    };

    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(adobeData);
  };

  // Build and push the "add_shipping_info" event (fires when donor details are completed)
  const pushAddShippingInfoAdobe = () => {
    const tempItems =
      basketStates.products && basketStates.products[0] && basketStates.products[0].product
        ? basketStates.products.map(item => ({
            item_id: item.product.creator,
            item_name: item.product.name,
            item_brand: item.product.category || '',
            item_description: item.product.description || '',
            item_category: item.product.category || '',
            price: item.amount,
            quantity: item.quantity,
            currency: basketStates.currency ? basketStates.currency.toUpperCase() : '',
          }))
        : [];

    const residencyMap = { UK: 'UK', USD: 'USA', AUD: 'AUS', FR: 'FR' };
    const adobeData = {
      event: 'add_shipping_info',
      page_info: {
        page_url: window.location.href,
        page_title: document.title,
        page_type: 'Checkout',
        language: i18n.language,
      },
      items: tempItems,
      order_summary: {
        admin_contribution: basketStates.adminCost || 0,
        donation_contribution:
          basketStates.grandTotal && basketStates.adminCost !== undefined ? basketStates.grandTotal - basketStates.adminCost : '',
        total_value: basketStates.grandTotal || '',
        donation_frequency: HandleShowRecurring(basketStates.recurring),
        residency: residencyMap[selectedPaymentFlow.value] || 'Private',
        currency: basketStates.currency ? basketStates.currency.toUpperCase() : '',
      },
    };

    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(adobeData);
  };

  /* ---------------------------------------------------------------------- */
  /* ---------------- End Adobe Analytics helpers section ----------------- */
  /* ---------------------------------------------------------------------- */

  const { i18n } = useTranslation();
  const lang = i18n.language;
  // const isDailyDonation = JSON.parse(localStorage.getItem('IS_DAILY_DONATION'));
  const { state } = location;
  /* --------------------- Trigger begin_checkout once -------------------- */
  useEffect(() => {
    if (!adobeBeginCheckoutFired.current && Object.keys(basketStates).length !== 0) {
      pushBeginCheckoutAdobe();
      adobeBeginCheckoutFired.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basketStates]);
  /* ---------------------------------------------------------------------- */
  useEffect(() => {
    let isBasketEmpty = true;
    for (let key in basketStates.donor) {
      if (basketStates.donor.hasOwnProperty(key)) {
        if (basketStates.donor[key] !== '') {
          isBasketEmpty = false; // If any field is not empty, return false
        }
      }
    }
    if (!isBasketEmpty) {
      if (userInfo.name && userInfo.phone && userInfo.phone_country_code && userInfo.email) {
        setIsLoaded(true);
        let formattedPhone = userInfo.phone;

        if (userInfo.phone_country_code === '44' && formattedPhone.startsWith('+44 0')) {
          formattedPhone = `+44 ${formattedPhone.slice(5)}`;
        }

        // Check if the phone number is valid
        const isValid = isValidPhoneNumber(formattedPhone, countryCode);

        setIsPhoneValid(isValid);
      }
    } else {
      setIsLoaded(true);
    }
  }, [userInfo, countryCode, basketStates]);

  useEffect(() => {
    if (userData && userData?.phone) {
      let formattedPhone = userInfo.phone;

      if (userInfo.phone_country_code === '44' && formattedPhone.startsWith('+44 0')) {
        formattedPhone = `+44 ${formattedPhone.slice(5)}`;
      }

      // Check if the phone number is valid
      const isValid = isValidPhoneNumber(formattedPhone, countryCode);

      setIsPhoneValid(isValid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);
  useEffect(() => {
    if (userInfo && userInfo?.phone) {
      let formattedPhone = userInfo.phone;

      if (userInfo.phone_country_code === '44' && formattedPhone.startsWith('+44 0')) {
        formattedPhone = `+44 ${formattedPhone.slice(5)}`;
      }

      // Check if the phone number is valid
      const isValid = isValidPhoneNumber(formattedPhone, countryCode);
      setIsPhoneValid(isValid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  // const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const postalCodeRegExp =
    /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})|[A-Z]{1,2}\d{1,2}(?:\s?\d?[A-Z]{0,2})?$/;
  // eslint-disable-next-line no-useless-escape
  const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // const emailRegExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const StepOneSchema = Yup.object().shape({
    name: Yup.string().min(3, 'Should be 3 character long').required('Enter your name'),
    // phone: Yup.string()
    //   .required('Enter your phone number')
    //   .test('isValid-phone', 'Phone number is not valid', value => isValidPhoneNumber(value)),
    email: Yup.string().matches(emailRegExp, 'Invalid email address').required('Enter your email address'),
    isUkTaxPayer: Yup.boolean(),
    address: Yup.string().when('isUkTaxPayer', {
      is: value => value === true,
      then: StepOneSchema => StepOneSchema.required('Enter your home address'),
      otherwise: StepOneSchema => StepOneSchema,
    }),
    city: Yup.string().when('isUkTaxPayer', {
      is: value => value === true,
      then: StepOneSchema => StepOneSchema.required('Enter your city'),
      otherwise: StepOneSchema => StepOneSchema,
    }),
    postal_code: Yup.string().when('isUkTaxPayer', {
      is: value => value === true,
      then: StepOneSchema => StepOneSchema.matches(postalCodeRegExp, 'Invalid postal code').required('Enter your postal code'),
      otherwise: StepOneSchema => StepOneSchema,
    }),
  });
  const notify = text =>
    toast.error(text, {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  const paymentsFlow = [
    { value: 'UK', label: 'I am a UK citizen' },
    { value: 'USD', label: 'I am a US Tax payer' },
    { value: 'AUD', label: 'I am an Australian citizen' },
    { value: 'FR', label: 'I am a French Citizen' },
    { value: 'OTHER', label: 'None of the above or remain private' },
  ];
  const [selectedPaymentFlow, setSelectedPaymentFlow] = useState(paymentsFlow[4]);

  // const handleSubmit = values => {
  //   if (!isPhoneValid) {
  //     notify('Please enter a valid phone number.');
  //     return;
  //   }

  //   setIsLoading(true);
  //   createUser(values);
  //   handleFinbixApi(values);
  // };

  const createUser = async values => {
    console.log("create user===", values)
    let tempBasket = basketStates;
    if (isLaylatulQadr) {
      let tempTotalProducts = 0;
      tempBasket.adminCost = 0;
      tempBasket.products.map(item => {
        item.product ? (tempTotalProducts += item.total) : (tempTotalProducts = 0);
        return null;
      });
      tempBasket.grandTotal = tempTotalProducts;
    }
    try {
      let tempUserIP = userIP;
      if (userIP === '') {
        fetch('https://matwproject.org/ip-api')
          .then(res => res.json())
          .then(response => {
            dispatch(setUserIP(response.query));
            tempUserIP = response.query;
            setCountryCode(response.countryCode);
            setCountryName(response.country);
            setPhoneCountryName(response.countryCode);
          })
          .catch((data, status) => {
            console.log('Request failed:', data);
          });
      }
      let tempUser = {
        name: values.name,
        email: values.email,
        phone: values.phone?.startsWith('+') ? values.phone : `+${values.phone}`,
        phone_country_code: userInfo.phone_country_code,
        currency: basketStates.currency,
        referal: document.referrer,
        host: window.location.protocol + '//' + window.location.host,
        ip: tempUserIP,
        acceptSms: isConsentChecked,
        acceptEmail: isEmailChecked,
        isGiftAid: isUkTaxPayer,
        grandTotal: tempBasket.grandTotal,
        address: userInfo.address,
        city: userInfo.city,
        postal_code: userInfo.postal_code,
        country_code: selectedPaymentFlow.value === 'UK' ? 'UK' : countryCode.toUpperCase(),
        country: selectedPaymentFlow.value === 'UK' ? 'United Kingdom' : countryName,
        // payment_flow: selectedPaymentFlow.value,
        payment_flow:
          selectedPaymentFlow.value === 'AUD'
            ? 'AU'
            : selectedPaymentFlow.value === 'USD'
            ? 'US'
            : selectedPaymentFlow.value === 'OTHER'
            ? 'UK'
            : selectedPaymentFlow.value,
      };
      const response = await services.createNewUserV2(tempUser);
      tempBasket.user = response.data;
      tempBasket.user = {
        ...tempBasket.user,
        phone_country_code: userInfo.phone_country_code,
        phone_country_name: userInfo.phone_country_name,
        referal: document.referrer,
        host: window.location.protocol + '//' + window.location.host,
        ip: tempUserIP,
        acceptSms: isConsentChecked,
        acceptEmail: isEmailChecked,
        isGiftAid: isUkTaxPayer,
        grandTotal: tempBasket.grandTotal,
        city: userInfo.city,
        country: selectedPaymentFlow.value === 'UK' ? 'United Kingdom' : countryName,
        payment_flow: selectedPaymentFlow.value,
        isUkTaxPayer: values.isUkTaxPayer,
      };
      tempBasket.donor = {
        name: values.name,
        email: values.email,
        phone: values.phone,
        phone_country_code: userInfo.phone_country_code,
        phone_country_name: userInfo.phone_country_name,
        countryCode: countryCode,
        // country: values.country ? values.country : countryName,
        country: countryName,
        address: values.address,
        city: values.city,
        postal_code: values.postal_code,
        isUkTaxPayer: values.isUkTaxPayer,
        isRemember: values.isRemember,
        acceptSms: isConsentChecked,
        acceptEmail: isEmailChecked
      };
      tempBasket.stripe_customer_id = response.data.id;
      tempBasket.paymentFlow = selectedPaymentFlow.value;
      let tempCustomerId =
        tempUser.payment_flow === 'US'
          ? response.data.us_stripe_id
          : tempUser.payment_flow === 'AU'
          ? response.data.au_stripe_id
          : response.data.uk_stripe_id;
      setStripeCustomerId(tempCustomerId);
      setPaymentFlow(selectedPaymentFlow.value);
      HandleLocalStorage(tempBasket);
      handleShippingInfoDataLayer(tempUser, response.data);
      pushAddShippingInfoAdobe(); // ---- Adobe Analytics add_shipping_info ----
      setIsLoading(false);
      let userDetailsDataLayerTemp = {
        event: 'user_details',
        user_id: tempBasket.user.id,
        email: tempBasket?.user.email,
        user_email_hashed: sha256(tempBasket?.user.email),
        phone: tempBasket?.user.phone,
        user_phone_hashed: sha256(tempBasket?.user.phone),
      };
      window.dataLayer = window.dataLayer || [];
      IsGTMScriptLoaded() && window.dataLayer.push(userDetailsDataLayerTemp);
      handlePaymentSelectionChange(selectedPaymentFlow.value);
      response.data.id && props.nextStep();
    } catch (error) {
      setIsLoading(false);
      // Check for server validation errors first
      const errData = error?.response?.data?.errors;
      const errorMessage = error?.response?.data?.message || error?.message || '';

      if (Object.keys(errData || {}).length > 0) {
        // Server validation errors - show the first error message
        const firstErrorKey = Object.keys(errData)[0];
        const firstErrorMessage = errData[firstErrorKey][0];

        // Make phone number errors more concise
        if (firstErrorMessage.toLowerCase().includes('phone') || firstErrorMessage.toLowerCase().includes('mobile')) {
          notify('Please enter a valid phone number');
        } else {
          notify(firstErrorMessage);
        }
      } else if (errorMessage.toLowerCase().includes('phone') || errorMessage.toLowerCase().includes('mobile')) {
        notify('Please enter a valid phone number');
      } else {
        notify('Something went wrong! please try later');
      }
      console.error('error========', error);
    }
  };

  // function validateIvoryCoastPhoneNumber(phone) {
  //   // Remove spaces and hyphens
  //   const cleaned = phone.replace(/[\s-]+/g, '');

  //   // If it's a domestic number (no country code), expect exactly 10 digits
  //   if (!cleaned.startsWith('+225')) {
  //     return /^\d{10}$/.test(cleaned);
  //   }

  //   // International format: remove the country code
  //   const localPart = cleaned.slice(4);

  //   // Ensure exactly 10 digits remain
  //   if (!/^\d{10}$/.test(localPart)) return false;

  //   // Valid operator prefixes for Ivory Coast (Côte d'Ivoire)
  //   const validPrefixes = ['01', '05', '07', '21', '25', '27'];
  //   const prefix = localPart.slice(0, 2);

  //   // Check if the prefix is one of the allowed values
  //   return validPrefixes.includes(prefix);
  // }

  const handleFinbixApi = values => {
    const utmData = getUTMData();
    const domainRegion = getDomainRegion(window.location.origin + window.location.pathname);
    const dataToTrack = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      acceptSms: isConsentChecked, // always send
      // Only send acceptEmail if the checkbox is shown (US, UAT, sabir-uat.matwproject.org)
      ...(domainRegion.region === 'US' || domainRegion.isUAT
        ? { acceptEmail: isEmailChecked }
        : {}),
      fingerprint: {
        ...fingerprint,
        userIP,
      },
      utmData,
    };

    fetch('https://matw.finbix.io/254fd2a6-5977-40be-8fad-95b5edfa0c98/api/campaign/utm', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataToTrack),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(responseText => {
        console.log('Tracking success:', responseText);
      })
      .catch(error => {
        console.error('Tracking error:', error);
      });
  };

  const handleOnPaste = event => {
    const pastedData = event.clipboardData.getData('Text');
    setPastedValue(pastedData);
  };

  const handlePhoneValidation = (value, country, setFieldValue) => {
    // Ensure the input value has the '+' prefix
    let inputValue = value.startsWith('+') ? value : `+${value}`;

    // Create an instance of AsYouType to format the phone number
    const asYouType = new AsYouType(country.countryCode);
    let formattedPhone = asYouType.input(inputValue);

    if (country.dialCode === '44' && formattedPhone.startsWith('+44 0')) {
      formattedPhone = `+44 ${formattedPhone.slice(5)}`;
    }

    // Check if the phone number is valid
    const isValid = country.dialCode === '225' ? true : isValidPhoneNumber(formattedPhone, country.countryCode);

    setIsPhoneValid(isValid);
    if (isValid) {
      // If the country is UK and the phone starts with zero after country code, remove it
      setUserInfo(prevState => ({
        ...prevState,
        phone: formattedPhone,
        phone_country_code: country.dialCode,
        phone_country_name: country.countryCode,
      }));
      setFieldValue('phone', formattedPhone);
      setPastedValue('');
      setPhoneError('');
    } else {
      setUserInfo(prevState => ({
        ...prevState,
        phone: formattedPhone,
        phone_country_code: country.dialCode,
        phone_country_name: country.countryCode,
      }));
      setFieldValue('phone', formattedPhone);
      setPastedValue('');
      setPhoneError('Invalid phone number. Please check and try again.');
    }
  };
  const handleInputsChange = (value, field) => {
    let tempBasket = basketStates;
    tempBasket.donor ? (tempBasket.donor[field] = value) : HandleLocalStorage(tempBasket);
  };
  const handleShippingInfoDataLayer = (userinfo, createdUser) => {
    let tempItems = basketStates.products[0].product
      ? basketStates.products.map(item => {
          return {
            item_id: item.product.creator,
            item_name: item.product.name,
            item_brand: item.product.category || '',
            item_category: item.product.category || '',
            item_description: item.product.description || '',
            price: item.amount,
            quantity: item.quantity,
          };
        })
      : [];
    let dataLayerTemp = {
      event: 'add_shipping_info',
      name: userinfo.name,
      email: userinfo.email,
      phone: userinfo.phone,
      user_email_hashed: sha256(userinfo.email),
      pay_id: createdUser.id,
      frequency: HandleShowRecurring(basketStates.recurring),
      ecommerce: {
        value: basketStates.grandTotal,
        tax: basketStates.adminCost,
        currency: basketStates.currency.toUpperCase(),
        items: tempItems,
      },
    };
    window.dataLayer = window.dataLayer || [];
    IsGTMScriptLoaded() && window.dataLayer.push(dataLayerTemp);
  };
  const handlePaymentFlow = e => {
    setIsUkTaxPayer(false);
    setUserInfo({
      ...userInfo,
      isUkTaxPayer: false,
    });
    setSelectedPaymentFlow({ ...selectedPaymentFlow, value: e.value, label: e.label });
  };

  const handleChildData = data => {
    setUserInfo({
      ...userInfo,
      city: data.locality,
      postal_code: data.postalCode,
    });
  };
  const getProductByCode = async (creator, currency, basketStates) => {
    const temp = { product: creator, currency: currency };
    try {
      const response = await services.getProduct(temp);
      let tempBasket = basketStates;
      let tempProduct = tempBasket.products[0];
      tempProduct.product.paypal_plans = response.data.paypal_plans;
      tempBasket.products[0] = tempProduct;
      setBasketStates(tempBasket); // Add new record to userProducts
      HandleLocalStorage(tempBasket);
    } catch (error) {
      toast.error("The product didn't find!");
    }
  };
  const formInitialValues = useMemo(
    () => ({
      name: userInfo.name,
      email: userInfo.email,
      phone: userInfo.phone,
      address: userInfo.address,
      city: userInfo.city,
      country: userInfo.country,
      postal_code: userInfo.postal_code,
      isUkTaxPayer: userInfo.isUkTaxPayer,
      isRemember: userInfo.isRemember,
    }),
    [userInfo],
  );
  const hasSetInitialInfo = useRef(false);
  const handleBack = values => {
    let tempBasket = basketStates;
    tempBasket.user = {
      ...tempBasket.user,
      name: values.name,
      email: values.email,
      phone: values.phone,
      phone_country_code: userInfo.phone_country_code,
      phone_country_name: userInfo.phone_country_name,
      acceptSms: isConsentChecked,
      acceptEmail: isEmailChecked,
      isGiftAid: isUkTaxPayer,
      address: userInfo.address,
      city: userInfo.city,
      postal_code: userInfo.postal_code,
      country_code: selectedPaymentFlow.value === 'UK' ? 'UK' : countryCode,
      countryCode: selectedPaymentFlow.value === 'UK' ? 'UK' : countryCode,
      country: selectedPaymentFlow.value === 'UK' ? 'United Kingdom' : countryName,
      payment_flow:
        selectedPaymentFlow.value === 'AUD'
          ? 'AU'
          : selectedPaymentFlow.value === 'USD'
          ? 'US'
          : selectedPaymentFlow.value === 'OTHER'
          ? 'UK'
          : selectedPaymentFlow.value,
      isUkTaxPayer: values.isUkTaxPayer,
    };
    tempBasket.donor = {
      ...tempBasket.donor,
      name: values.name,
      email: values.email,
      phone: values.phone,
      phone_country_code: userInfo.phone_country_code,
      phone_country_name: userInfo.phone_country_name,
      countryCode: countryCode,
      country: countryName,
      address: values.address,
      city: values.city,
      postal_code: values.postal_code,
      isUkTaxPayer: values.isUkTaxPayer,
      isRemember: values.isRemember,
      acceptSms: isConsentChecked,
      acceptEmail: isEmailChecked
    };
    tempBasket.paymentFlow = selectedPaymentFlow.value;
    HandleLocalStorage(tempBasket);
    if (state && state.from) {
      navigate(`/${generateLinkWithLang(state.from, lang)}`);
    } else {
      props.backStep();
    }
  };
  // Function to dynamically update the script tag in the head
  const customUseScriptOnHead = entityId => {
    // Remove any existing Chargebee script if present
    const existingScript = document.querySelector('script[data-cb-site]');
    if (existingScript) {
      existingScript.remove();
    }

    // Create a new script element
    const script = document.createElement('script');
    script.src = 'https://js.chargebee.com/v2/chargebee.js';
    script.type = 'text/javascript';
    script.setAttribute('data-cb-site', 'matw');
    script.setAttribute('data-cb-business-entity-id', entityId); // Dynamically set the business entity ID
    // script.setAttribute('data-cb-business-entity-id', 'MATW-Australia'); // Only Australia
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  // Function to handle user selection change
  const handlePaymentSelectionChange = selectedValue => {
    let entityId = '';

    switch (selectedValue) {
      case 'USD':
        entityId = 'MATW-USA';
        break;
      case 'UK':
        entityId = 'MATW-UK';
        break;
      case 'FR':
        entityId = 'MATW-France';
        break;
      case 'AUD':
        entityId = 'MATW-Australia';
        break;
      case 'OTHER':
      default:
        entityId = 'MATW-UK'; // Default to UK if 'OTHER' or 'FR' is selected
        break;
    }

    // Dynamically update the script based on the selection
    customUseScriptOnHead(entityId);
  };
  /* -------------------------------------------------------------------------- */

  /* ---------------------------------- Hooks --------------------------------- */
  useEffect(() => {
    if (!hasSetInitialInfo.current && Object.keys(basketStates).length !== 0) {
      let tempUkTaxPayer =
        basketStates.paymentFlow === 'UK' &&
        basketStates.donor &&
        basketStates.donor.postal_code &&
        (basketStates.donor.isUkTaxPayer || basketStates.user.isUkTaxPayer)
          ? true
          : false;
      setUserInfo({
        ...userInfo,
        name: basketStates.donor && basketStates.donor.name ? basketStates.donor.name : userData && userData.name ? userData.name : '',
        email: basketStates.donor && basketStates.donor.email ? basketStates.donor.email : userData && userData.email ? userData.email : '',
        phone: basketStates.donor && basketStates.donor.phone ? basketStates.donor.phone : userData && userData.phone ? userData.phone : '',
        phone_country_code: basketStates.donor ? basketStates.donor.phone_country_code : '',
        phone_country_name: basketStates.donor ? basketStates.donor.phone_country_name : '',
        currency: basketStates.currency ? basketStates.currency : 'AUD',
        country: basketStates.donor ? basketStates.donor.country : '',
        address: basketStates.donor ? basketStates.donor.address : '',
        city: basketStates.donor ? basketStates.donor.city : '',
        postal_code: basketStates.donor ? basketStates.donor.postal_code : '',
        // isUkTaxPayer: basketStates.donor.postal_code ? true : false,
        isUkTaxPayer: tempUkTaxPayer,
        isRemember: basketStates.donor?.isRemember ?? true,
      });
      setIsUkTaxPayer(tempUkTaxPayer);
      hasSetInitialInfo.current = true;

      setIsConsentChecked(basketStates?.donor?.acceptSms ?? false);
      setIsEmailChecked(basketStates?.donor?.acceptEmail ?? false);

      let tempPaymentFlow = basketStates.paymentFlow ? basketStates.paymentFlow : 'OTHER';
      if (!basketStates.paymentFlow) {
        fetch('https://matwproject.org/ip-api')
          .then(res => res.json())
          .then(response => {
            switch (response.countryCode) {
              case 'AU':
                tempPaymentFlow = 'AUD';
                break;
              case 'US':
                tempPaymentFlow = 'USD';
                break;
              default:
                tempPaymentFlow = 'OTHER';
            }
            if (response.timezone.includes('Europe')) {
              if (response.countryCode === 'GB') {
                tempPaymentFlow = 'UK';
              } else if (response.countryCode === 'FR') {
                tempPaymentFlow = 'FR';
              } else {
                tempPaymentFlow = 'OTHER';
              }
            }
            paymentsFlow.map(item => {
              if (item.value === tempPaymentFlow) {
                setSelectedPaymentFlow(item);
              }
              return item;
            });
          })
          .catch(data => {
            console.log('Request failed:', data);
          });
      } else {
        paymentsFlow.map(item => {
          if (item.value === tempPaymentFlow) {
            setSelectedPaymentFlow(item);
          }
          return item;
        });
      }
      if (basketStates.paymentFlow) {
        tempPaymentFlow = basketStates.paymentFlow;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basketStates]);
  useEffect(() => {
    if (userIP === '') {
      fetch('https://matwproject.org/ip-api')
        .then(res => res.json())
        .then(response => {
          dispatch(setUserIP(response.query));
          setCountryCode(response.countryCode);
          setCountryName(response.country);
          setPhoneCountryName(response.countryCode);
        })
        .catch((data, status) => {
          console.log('Request failed:', data);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userIP]);
  useEffect(() => {
    const isUSADomain = window.location.hostname === 'matwprojectusa.org' || window.location.hostname === 'uat.matwproject.org';

    if (isUSADomain) {
      setIsConsentChecked(true);
    }
  }, []);
  useEffect(() => {
    const basketStatesFromLocalStorage = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
    if (basketStatesFromLocalStorage) {
      if (
        basketStatesFromLocalStorage.products.length === 1 &&
        !basketStatesFromLocalStorage.adminCost &&
        basketStatesFromLocalStorage.mode === 'subscription'
      ) {
        getProductByCode(
          basketStatesFromLocalStorage.products[0].product.creator,
          basketStatesFromLocalStorage.currency,
          basketStatesFromLocalStorage,
        );
      }
      setBasketStates(basketStatesFromLocalStorage);
    }
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    if (!basketStates.donor) {
      fetch('https://matwproject.org/ip-api')
        .then(res => res.json())
        .then(response => {
          setCountryCode(response.countryCode);
          setCountryName(response.country);
          setPhoneCountryName(response.countryCode);
        })
        .catch((data, status) => {
          console.log('Request failed:', data);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const storedFingerprint = generateFingerprint();
    setFingerprint(storedFingerprint);
  }, []);

  /* -------------------------------------------------------------------------- */
  return (
    <div className="w-full">
      <div className="content p-3 md:p-5">
        <Formik
          enableReinitialize
          // initialValues={{
          //   name: userInfo.name,
          //   email: userInfo.email,
          //   phone: userInfo.phone,
          //   address: userInfo.address,
          //   city: userInfo.city,
          //   country: userInfo.country,
          //   postal_code: userInfo.postal_code,
          //   isUkTaxPayer: userInfo.isUkTaxPayer,
          //   isRemember: userInfo.isRemember,
          // }}
          validateOnMount={true}
          initialValues={formInitialValues}
          validationSchema={StepOneSchema}
          onSubmit={(values, actions) => {
            // handleSubmit(values);
            if (!isPhoneValid) {
              notify('Please enter a valid phone number.');
              return;
            }

            actions.validateForm().then(errors => {
              if (Object.keys(errors).length === 0) {
                setIsLoading(true);
                createUser(values);
                handleFinbixApi(values);
              } else {
                notify('Please complete the required fields.');
              }
            });
          }}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, setFieldTouched }) => {
            return <>
              <FormikSync userInfo={userInfo} />
                <form onSubmit={handleSubmit} id="user_info_form" className={`${lang === 'ar' && 'user_info_form-ar'}`}>
                <div className="grid sm:grid-cols-4 md:grid-cols-3 gap-4">
                  {isLoaded ? (
                    <>
                      <div className="col-span-3 sm:col-span-2 md:col-span-1">
                        <label className="text-sm md:text-md text-[#777]">
                          Name<small className="text-[#f60362] text-lg leading-4 ml-1">*</small>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Enter your name"
                            className="min-h-[40px] md:min-h-[48px] w-full text-base md:text-md rounded border border-stone-300 bg-transparent py-[0.32rem] px-3 outline-none transition-all duration-200 ease-linear text-[#000]"
                            onBlur={handleBlur}
                            value={userInfo.name}
                            onChange={e => {
                              handleChange(e);
                              handleInputsChange(e.target.value, 'name');
                              setUserInfo({
                                ...userInfo,
                                name: e.target.value,
                              });
                            }}
                          />
                          {errors.name && touched.name && (
                            <small id="name-error" className="text-[#f60362] text-sm">
                              {errors.name}
                            </small>
                          )}
                        </label>
                      </div>
                      <div className="col-span-3 sm:col-span-2 md:col-span-1 z-[11]">
                        <label className="text-sm md:text-md text-[#777] w-full [&>div]:[direction:ltr]">
                          Phone<small className="text-[#f60362] text-lg leading-4 ml-1">*</small>
                          <PhoneInput
                            name="phone"
                            className="min-h-[40px] md:min-h-[48px] w-full [&>input]:!text-base [&>input]:!w-full [&>input]:!text-[#000] [&>input]:!font-brandingMedium"
                            id="phone"
                            placeholder="Enter your phone number"
                            onBlur={val => {
                              let e = { target: { value: val, name: 'phone', id: 'phone' } };
                              handleBlur(e);
                            }}
                            inputClass={'!w-full'}
                            country={
                              userData && userData.countryCode
                                ? userData.countryCode.toLowerCase()
                                : basketStates.donor && basketStates.donor.phone_country_name
                                  ? basketStates.donor.phone_country_name.toLowerCase()
                                  : phoneCountryName.toLowerCase()
                            }
                            value={userInfo.phone}
                            autoFormat={ciDialCode}
                            onChange={(val, country) => {
                              console.log("pone==",val)
                              let e = { target: { value: val, name: 'phone', id: 'phone' } };

                                setCiDialCode(country.dialCode !== '225');

                              handlePhoneValidation(
                                pastedValue && pastedValue.length > 0
                                  ? pastedValue.startsWith(`+${country.dialCode}`)
                                    ? pastedValue
                                    : `${country.dialCode}${pastedValue}`
                                  : val,
                                country,
                                setFieldValue,
                              );
                              // setCountryName(country.name);
                              // setCountryCode(country.countryCode);
                              setPhoneCountryName(country.countryCode);
                              handleChange(e);
                              // let _country = { target: { value: country.name, name: 'country', id: 'country' } };
                              // handleChange(_country);
                            }}
                            inputProps={{
                              onPaste: handleOnPaste,
                            }}
                          />
                          {(phoneError || errors.phone) && (
                            <small id="phone-error" className="text-[#f60362] text-sm">
                              {phoneError ? phoneError : errors.phone}
                            </small>
                          )}
                        </label>
                      </div>
                      <div className="col-span-3 sm:col-span-2 md:col-span-1">
                        <label className="text-sm md:text-md text-[#777]">
                          Email<small className="text-[#f60362] text-lg leading-4 ml-1">*</small>
                          <input
                            type="text"
                            name="email"
                            id="email"
                            placeholder="Enter your email"
                            className="min-h-[40px] md:min-h-[48px] w-full text-base md:text-md rounded border border-stone-300 bg-transparent py-[0.32rem] px-3 outline-none transition-all duration-200 ease-linear text-[#000]"
                            onBlur={handleBlur}
                            value={userInfo.email}
                            onChange={e => {
                              const trimmedValue = e.target.value.trim();
                              handleChange({ ...e, target: { ...e.target, value: trimmedValue } });
                              handleInputsChange(trimmedValue, 'email');
                              setUserInfo({
                                ...userInfo,
                                email: trimmedValue,
                              });
                            }}
                          />
                          {errors.email && touched.email && (
                            <small id="email-error" className="text-[#f60362] text-sm">
                              {errors.email}
                            </small>
                          )}
                        </label>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                  <div className={`col-span-3 flex items-center mt-2 ${lang === 'ar' ? '[&>input]:mr-0 [&>input]:ml-1 [&>input]:[direction:ltr]' : ''}`}>
                    <CheckBox
                      name="consentcheckbox"
                      // value={isConsentChecked}
                      checked={!!isConsentChecked}
                      setter={e => {
                        setIsConsentChecked(e);
                        setBasketStates(prev => {
                          const updated = {
                            ...prev,
                            donor: {
                              ...prev.donor,
                              acceptSms: e
                            }
                          };
                          HandleLocalStorage(updated);
                          return updated;
                        });
                      }}
                      lang={lang}>
                        {(domainRegion.region === 'US' || domainRegion.isUAT) ? (
                        <span>
                          I agree to receive SMS messages for updates and marketing.
                        </span>
                      ) : (
                        <span>
                          I agree to receive Email, WhatsApp/SMS text messages and SMS data rates may apply. Reply STOP to cancel,<a className="text-[#00a3da] pl-1" target={'_blank'} href="/privacypolicy/"> See Privacy Policy.</a>
                        </span>
                      )}
                    </CheckBox>
                  </div>
                  {/* Only show the email consent checkbox on US, UAT, or sabir-uat.matwproject.org domains */}
                  {(domainRegion.region === 'US' || domainRegion.isUAT) && (
                    <div className={`col-span-3 flex items-center mt-2 ${lang === 'ar' ? '[&>input]:mr-0 [&>input]:ml-1 [&>input]:[direction:ltr]' : ''}`}>
                        <CheckBox
                          name="isEmailChecked"
                          checked={!!isEmailChecked}
                          setter={e => {
                            setIsEmailChecked(e);
                            setBasketStates(prev => {
                              const updated = {
                                ...prev,
                                donor: {
                                  ...prev.donor,
                                  acceptEmail: e
                                }
                              };
                              HandleLocalStorage(updated);
                              return updated;
                            });
                          }}
                          lang={lang}>
                          <span>
                            I agree to receive emails from MATW Project,<a className="text-[#00a3da] pl-1" target={'_blank'} href="/privacypolicy/"> See Privacy Policy.</a>
                          </span>
                        </CheckBox>
                    </div>
                  )}
                  <div className="col-span-3 sm:col-span-4 flex flex-wrap items-center mt-2 hidden-">
                    <div className="basis-full flex flex-col mb-3 pr-2 z-10">
                      <label htmlFor="paymentsFlow" className="text-[#78716C]">
                        Your residency or tax status:
                      </label>
                      <Select
                        options={paymentsFlow}
                        placeholder="Select Payment Flow"
                        value={selectedPaymentFlow}
                        styles={styles}
                        className="!text-[#78716C]"
                        name="paymentsFlow"
                        isSearchable={false}
                        inputId='donorPaymentsFlow'
                        onChange={e => {
                          handlePaymentFlow(e);
                        }}
                      />
                    </div>
                    {selectedPaymentFlow.value === 'UK' && (
                      <>
                        <p className="text-[#f60362] text-base basis-full font-medium mb-4">
                          Are you a UK taxpayer? Add an additional 25p for every £1 you donate for free.
                        </p>
                        <div className={`flex items-center ${lang === 'ar' ? '[&>input]:mr-0 [&>input]:ml-1 [&>input]:[direction:ltr]' : ''}`}>
                          <Field name="isUkTaxPayer">
                            {({ field, form }) => (
                              <CheckBox
                                name="isUkTaxPayer"
                                // value={userInfo.isUkTaxPayer}
                                checked={!!userInfo.isUkTaxPayer}
                                className="mt-1"
                                setter={val => {
                                  let e = { target: { value: val, name: 'isUkTaxPayer', id: 'isUkTaxPayer' } };
                                  handleChange(e);
                                  setUserInfo({
                                    ...userInfo,
                                    isUkTaxPayer: val,
                                  });
                                  setIsUkTaxPayer(val);
                                  setFieldValue('isUkTaxPayer', val); // <-- THIS IS CRITICAL
                                  setBasketStates(prev => {
                                    const updated = {
                                      ...prev,
                                      paymentFlow: val ? 'UK' : prev.paymentFlow
                                    };
                                    HandleLocalStorage(updated);
                                    return updated;
                                  });
                                }}
                                label={`I am a UK tax payer (we’ll claim gift aid on your behalf)`}
                          lang={lang}
                              />
                            )}
                          </Field>
                        </div>
                        {isUkTaxPayer && (
                          <div className={`w-full flex flex-wrap items-center`}>
                            <div className="basis-full flex flex-col items-center justify-center my-6">
                              <div className="flex border-2 border-dotted border-stone-300 rounded-md w-full md:w-auto py-4 md:py-8 px-2 md:px-4 relative">
                                {console.log("lang====", lang)}
                                <div className={`flex rounded-full bg-[#71DAFF] text-white justify-center items-center ${lang === 'ar' ? 'ml-2 md:ml-6' : 'mr-2 md:mr-6'} text-sm md:text-base text-center px-1 md:px-0 py-1 md:py-2 w-1/3 md:w-[170px] z-[1]`}>
                                  {ShowCurrencies(basketStates.currency, basketStates.grandTotal, false)}
                                </div>
                                <div className={`flex rounded-full bg-[#16C4FF] text-white justify-center items-center ${lang === 'ar' ? 'ml-2 md:ml-6' : 'mr-2 md:mr-6'} text-sm md:text-base text-center max-[537px]:flex-col px-1 md:px-0 py-1 md:py-2 w-1/3 md:w-[170px] z-[1]`}>
                                  +25% Free <span className="ml-1">Gift Aid</span>
                                </div>
                                <div className="flex rounded-full bg-[#00A3DA] text-white justify-center items-center text-sm md:text-base text-center px-1 md:px-0 py-1 md:py-2 w-1/3 md:w-[170px] z-[1]">
                                  {ShowCurrencies(basketStates.currency, basketStates.grandTotal + basketStates.grandTotal * 0.25, false)}
                                </div>
                                <div className="border-t-2 border-dotted border-[#00A3DA] w-[90%] h-[1px] absolute left-0 right-0 mr-auto ml-auto top-1/2 z-[0]" />
                              </div>
                            </div>
                            <div className="basis-full grid grid-cols-6 gap-2">
                              <div className="col-span-6 lg:col-span-3 md:min-h-[96px]">
                                <AddressField
                                  name="address"
                                  label="Home Address"
                                  defaultValue={userInfo.address}
                                  placeholder={'Enter your home address'}
                                  setFieldValue={setFieldValue}
                                  errors={errors.address}
                                  handleBlur={handleBlur}
                                  handleChange={e => {
                                    handleChange(e);
                                    setFieldValue('address', e.target.value);
                                    setUserInfo({
                                      ...userInfo,
                                      address: e.target.value,
                                    });
                                    setBasketStates(prev => {
                                      const updated = {
                                        ...prev,
                                        donor: {
                                          ...prev.donor,
                                          address: e.target.value
                                        }
                                      };
                                      HandleLocalStorage(updated);
                                      return updated;
                                    });
                                  }}
                                  touched={touched.address}
                                  cityName="city"
                                  onData={handleChildData}
                                  value={userInfo.address}
                                />
                              </div>
                              <div className="col-span-6 md:col-span-3 md:min-h-[96px]">
                                <AddressField
                                  name="city"
                                  label="City"
                                  defaultValue={userInfo.city}
                                  placeholder={'Enter your city'}
                                  types={['locality']}
                                  setFieldValue={setFieldValue}
                                  errors={errors.city}
                                  handleBlur={handleBlur}
                                  handleChange={e => {
                                    handleChange(e);
                                    setFieldValue('city', e.target.value);
                                    setUserInfo({
                                      ...userInfo,
                                      city: e.target.value,
                                    });
                                    setBasketStates(prev => {
                                      const updated = {
                                        ...prev,
                                        donor: {
                                          ...prev.donor,
                                          city: e.target.value
                                        }
                                      };
                                      HandleLocalStorage(updated);
                                      return updated;
                                    });
                                  }}
                                  touched={touched.city}
                                  value={userInfo.city}
                                />
                              </div>
                              <div className="col-span-6 md:col-span-3 md:min-h-[96px]">
                                <label className="text-sm md:text-md text-[#777]">
                                  Postal Code<small className="text-[#f60362] text-lg leading-4 ml-1">*</small>
                                  <input
                                    type="text"
                                    name="postal_code"
                                    id="postal_code"
                                    placeholder="Enter your postal code"
                                    className="min-h-[40px] md:min-h-[48px] w-full text-base md:text-md rounded border border-stone-300 bg-transparent py-[0.32rem] px-3 outline-none transition-all duration-200 ease-linear text-[#000]"
                                    onBlur={handleBlur}
                                    value={userInfo.postal_code}
                                    onChange={e => {
                                      handleChange(e);
                                      setUserInfo({
                                        ...userInfo,
                                        postal_code: e.target.value,
                                      });
                                      setBasketStates(prev => {
                                        const updated = {
                                          ...prev,
                                          donor: {
                                            ...prev.donor,
                                            postal_code: e.target.value
                                          }
                                        };
                                        HandleLocalStorage(updated);
                                        return updated;
                                      });
                                    }}
                                  />
                                  {errors.postal_code && touched.postal_code && (
                                    <small id="postal_code-error" className="text-[#f60362] text-sm">
                                      {errors.postal_code}
                                    </small>
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className={`col-span-3 flex items-center mt-2 ${lang === 'ar' ? '[&>input]:mr-0 [&>input]:ml-1 [&>input]:[direction:ltr]' : ''}`}>
                    <CheckBox
                      name="isRemember"
                      // value={userInfo.isRemember}
                      checked={!!userInfo.isRemember}
                      setter={val => {
                        let e = { target: { value: val, name: 'isRemember', id: 'isRemember' } };
                        handleChange(e);
                        setUserInfo({
                          ...userInfo,
                          isRemember: val,
                        });
                      }}
                    lang={lang}
                    >
                      <span>Remember my details</span>
                    </CheckBox>
                  </div>
                </div>
                <div className="grid grid-cols-6 mt-8 gap-2 md:gap-4">
                  <div className="col-start-1 col-span-2 md:col-span-1">
                    <button
                      type="button"
                      className="w-full flex items-center justify-center rounded px-6 pt-2 pb-2 font-normal md:text-lg md:h-[48px] transition duration-200 bg-[#00a3da] text-white sm:px-2 hover:bg-[#f60362] focus:outline-none focus:ring-0"
                      onClick={() => {
                        handleBack(values);
                        // if (state && state.from) {
                        //   navigate(`/${generateLinkWithLang(state.from, lang)}`);
                        // } else {
                        //   props.backStep();
                        // }
                        // if (isLaylatulQadr) {
                        //   navigate(generateLinkWithLang('/ramadan/last-10-nights', lang));
                        // } else if(isDailyDonation) {
                        //   navigate(generateLinkWithLang('/30-steps-to-jannah', lang));
                        // } else {
                        //   props.backStep();
                        // }
                      }}
                    >
                      Back
                    </button>
                    {/* { state: { from: "30-steps-to-jannah" } } */}
                  </div>
                  <div className="col-span-4 sm:col-span-3 sm:col-start-4 md:col-start-5 md:col-span-2">
                    <button
                      type="submit"
                      disabled={isLoading}
                      className={`w-full flex items-center justify-center rounded px-6 pt-2 pb-2 font-normal md:text-lg md:h-[48px] transition duration-150 ease-in-out bg-[#f60362] text-white focus:bg-[#00a3da] focus:outline-none focus:ring-0 active:bg-[#00a3da] hover:bg-[#00a3da]`}
                    >
                      {isLoading ? (
                        <>
                          Processing...
                          <svg className="animate-spin ml-4 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                        </>
                      ) : (
                        <>
                          <span>Next</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                          className={`group-hover:ml-2 h-5 ml-1 transition-all duration-150 ease-in ${lang === 'ar' ? 'rotate-180' : ''}`}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                          </svg>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </>
          }}
        </Formik>
      </div>
    </div>
  );
};

const FormikSync = ({ userInfo }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  useEffect(() => {
    if (userInfo) {
      Object.entries(userInfo).forEach(([key, val]) => {
        setFieldValue(key, val);
        if (key === 'isUkTaxPayer' && val === true) {
          setFieldTouched(key, true); // force validation
        }
      });
    }
  }, [userInfo, setFieldValue, setFieldTouched]);

  return null; // no UI, just syncing
};

export default StepTwoWithLocalStorage;
